var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoIconsRu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17.1 11.4",
    style: {
      enableBackground: "new 0 0 17.1 11.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#405C40;}\r\n\t.st1{clip-path:url(#SVGID_00000134955714324219182860000001209210301692528008_);fill:#405C40;}\r\n\t.st2{clip-path:url(#SVGID_00000017483845965559209290000003912631977151506846_);fill:#405C40;}\r\n\t.st3{clip-path:url(#SVGID_00000177471130863042837010000003947994518132963724_);fill:#405C40;}\r\n\t.st4{clip-path:url(#SVGID_00000065790300006724885010000004114651385831237297_);fill:#405C40;}\r\n\t.st5{clip-path:url(#SVGID_00000144307641408884276380000017913622942610792325_);fill:#405C40;}\r\n\t.st6{fill:#CD2D40;}\r\n\t.st7{fill:#0D468F;}\r\n\t.st8{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 7.6,
    className: "st6",
    width: 17.1,
    height: 3.8
  }), /*#__PURE__*/React.createElement("rect", {
    y: 3.8,
    className: "st7",
    width: 17.1,
    height: 3.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st8",
    width: 17.1,
    height: 3.8
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconsRu);
export default __webpack_public_path__ + "static/media/InfoIcons_Ru.7c833dc60422877f988070e8cd116655.svg";
export { ForwardRef as ReactComponent };